import { useQuery } from '@apollo/client';
import { Link } from 'react-router-dom';
import { SearchBar } from '../../components/search-bar';
import { GetCategories } from '../../queries';

const HomePage = () => {
  const { data: categoryData } = useQuery(GetCategories);
  const categories = categoryData?.categories?.nodes;

  return (
    <div className="dx-main">
      <header className="dx-header dx-box-1">
        <div className="container">
          <div className="bg-image bg-image-parallax">
            <img
              src="assets/images/bg-header-4.png"
              className="jarallax-img"
              alt=""
            />
            <div style={{ backgroundColor: 'rgba(27, 27, 27, .2)' }}></div>
          </div>

          <div className="row justify-content-center">
            <div className="col-xl-7">
              <SearchBar />
            </div>
          </div>
        </div>
      </header>

      <div className="container py-md-4">
        <div className="row">
          <div className="col-md-3">
            <ul>
              {categories?.map((e: any) => (
                <li key={e?.slug}>
                  <Link to={`/danh-muc/${e?.slug}`}>{e?.name}</Link>
                </li>
              ))}
            </ul>
          </div>
          <div className="col-md-9"></div>
        </div>
      </div>
    </div>
  );
};

export default HomePage;
